<span
    (click)="onClickNode(node)"
    class="node-label"
    [ngClass]="{
        selected: node.partitionDetails.code === selectedNodeCode,
        edited: node.simulationValues && node.simulationValues.flag === flagType.modified,
        inherited: node.simulationValues && node.simulationValues.flag === flagType.inherited
    }">
    {{node.partitionDetails.text?.shortLabel}}
</span>
